/* eslint-disable object-shorthand */
/* eslint-disable prefer-arrow-callback */
/* eslint-disable vars-on-top */
/* eslint-disable strict */
/* eslint-disable no-var */
/* eslint-disable complexity */
(async function(algolia) {
  'use strict';
  var instantsearch = algolia.externals.instantsearch;
  var algoliasearch = algolia.externals.algoliasearch;
  var searchBox = algolia.externals.widgets.searchBox;
  var stats = algolia.externals.widgets.stats;
  var sortBy = algolia.externals.widgets.sortBy;
  var clearRefinements = algolia.externals.widgets.clearRefinements;
  var panel = algolia.externals.widgets.panel;
  var hits = algolia.externals.widgets.infiniteHits;
  var pagination = algolia.externals.widgets.pagination;
  var configure = algolia.externals.widgets.configure;
  var index_suffix = await algolia.config.index_suffix;
  var connectCurrentRefinements =
    algolia.externals.connectors.connectCurrentRefinements;

  var collectionPageEnabled =
    algolia.is_collection_results_page &&
    algolia.config.instant_search_enabled_on_collection;

  if (!algolia.full_results && !algolia.is_collection_results_page) {
    /**
     * If we aren't on the search page and neither on a collection page,
     * then there's no need to proceed
     */
    return;
  } else if (algolia.full_results) {
    /**
     * If we are on the search page and instant search isn't enabled,
     * then there's no need to proceed
     */
    if (!algolia.config.instant_search_enabled) {
      return;
    }
  } else if (algolia.is_collection_results_page) {
    /**
     * If we are on a collection page and instant search on collection isn't
     * enabled, then there's no need to proceed
     */
    if (!algolia.config.instant_search_enabled_on_collection) {
      return;
    }
  }

  /**
   * Array which will contain all filters to be applied while initiating the
   * search API call.
   */
  var searchFilters = [];

  var collectionFacetFilter = null;
  var collectionRulesContextValue = null;
  var collectionHandle = null;

  if (collectionPageEnabled) {
    var matches = window.location.pathname.match(/\/collections\/([^/]+)/i);
    collectionHandle =
      Boolean(matches) && matches.length === 2 ? matches[1] : null;

    if (algolia.config.collection_id_indexing) {
      collectionFacetFilter = algolia.current_collection_id
        ? 'collection_ids:"' + algolia.current_collection_id + '"'
        : null;
    } else {
      collectionFacetFilter = 'collections:"' + collectionHandle + '"';
    }

    // Add the collection filter to the list of search filters
    searchFilters.push(collectionFacetFilter);

    collectionRulesContextValue = algolia.config.collection_id_query_rules
      ? algolia.current_collection_id
      : collectionHandle;
  }

  // Filters for stock policy
  var stockPolicyFilter = null;
  if (algolia.config.stock_policy) {
    if (algolia.config.stock_policy === 'allow') {
      /**
       * For 'allow', we don't need to add any filter as we want to continue
       * displaying all out of stock items.
       */
    } else if (algolia.config.stock_policy === 'deny') {
      // For 'deny' we will filter out all items based on inventory quantity
      stockPolicyFilter = 'inventory_quantity > 0';
    } else if (algolia.config.stock_policy === 'continue') {
      /**
       * For 'continue' we will filter on `inventory_available` attribute whose
       * value is dependent on:
       * `inventory_quantity > 0 OR inventory_policy == 'continue'`
       */
      stockPolicyFilter = 'inventory_available:true';
    }

    // Add the stock policy filter to the list of search filters
    if (stockPolicyFilter) {
      searchFilters.push(stockPolicyFilter);
    }
  }

  var results_selector = collectionPageEnabled
    ? algolia.config.collection_css_selector
    : algolia.config.results_selector;

  var activeSortOrders =
    collectionPageEnabled && algolia.collectionSortOrders
      ? algolia.collectionSortOrders
      : algolia.sortOrders;

  results_selector += ', .algolia-shopify-instantsearch';

  function getTrackedUiState(uiState) {
    var trackedUiState = {};
    Object.keys(uiState).forEach(function(k) {
      if (k === 'configure' || k === 'query' || k === 'q') {
        return;
      }
      trackedUiState[k] = uiState[k];
    });
    return trackedUiState;
  }

  /**
   * List of URL params which are "allowed" by InstantSearch.
   * These parameters won't be overwritten when the search state is written
   * to the URL.
   */
  var ALLOWED_FOREIGN_PARAMS = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_term',
    'utm_content',
  ];
  var foreignRouteState;

  function singleIndex(indexName) {
    return {
      /**
       * `stateToRoute` method transforms the `uiState` object from InstantSearch
       * into an object that will then be serialized to construct the URL.
       */
      stateToRoute: function(uiState) {
        var route = getTrackedUiState(uiState[indexName] || {});
        route.q = uiState[indexName].query;
        return Object.assign({}, foreignRouteState, route);
      },

      /**
       * `routeToState` method transforms the route object into a `uiState` object
       * so that InstantSearch is initialized with the correct state from the
       * URL.
       */
      routeToState: function(routeState) {
        /**
         * Backup parameters from `routeState` into a different object
         * `foreignRouteState` so that we can re-inject them into the object
         * returned within `stateToRoute`.
         * This allows us to preserve the parameters specified in `ALLOWED_FOREIGN_PARAMS`
         * array.
         */
        if (!foreignRouteState) {
          foreignRouteState = ALLOWED_FOREIGN_PARAMS.reduce(function(acc, key) {
            acc[key] = routeState[key];
            return acc;
          }, {});
        }

        var state = {};
        state[indexName] = getTrackedUiState(routeState || {});
        state[indexName].query = routeState.q;
        return state;
      },
    };
  }

  var instant = {
    colors: algolia.config.colors,
    distinct: Boolean(algolia.config.show_products),
    facets: {
      hidden:
        collectionPageEnabled && algolia.collectionHiddenFacets
          ? algolia.collectionHiddenFacets
          : algolia.hiddenFacets,
      shown:
        collectionPageEnabled && algolia.collectionShownFacets
          ? algolia.collectionShownFacets
          : algolia.shownFacets,
      list:
        collectionPageEnabled && algolia.collectionFacets
          ? algolia.collectionFacets
          : algolia.facets,
      widgets:
        collectionPageEnabled && algolia.collectionFacetsWidgets
          ? algolia.collectionFacetsWidgets
          : algolia.facetsWidgets,
    },
    hitsPerPage:
      collectionPageEnabled &&
      algolia.config.collections_full_results_hits_per_page
        ? algolia.config.collections_full_results_hits_per_page
        : algolia.config.products_full_results_hits_per_page,
    search: instantsearch({
      searchClient: algoliasearch(
        algolia.config.app_id,
        algolia.config.search_api_key
      ),
      insights: true,
      indexName: algolia.config.index_prefix + 'products' + index_suffix,
      routing: {
        stateMapping: singleIndex(algolia.config.index_prefix + 'products' + index_suffix),
      },
      searchFunction: function(searchFunctionHelper) {
        // Set query parameters here because they're not kept when someone
        // presses the Back button if set in the `init` function of a custom widget
        var page = searchFunctionHelper.getPage();
        if (instant.distinct) {
          searchFunctionHelper.setQueryParameter('distinct', true);
        }

        // Assign any required filters
        if (searchFilters.length) {
          searchFunctionHelper.setQueryParameter(
            'filters',
            searchFilters.join(' AND ')
          );
        }

        // Assign any required `ruleContexts` which are required for query rules
        // targeting collection pages
        if (collectionPageEnabled) {
          // Collection page merchandising:
          // If we are on a collection page, `collectionRulesContextValue` is defined
          if (collectionRulesContextValue) {
            searchFunctionHelper.setQueryParameter('ruleContexts', [
              collectionRulesContextValue.toString(),
            ]);
          } else {
            searchFunctionHelper.setQueryParameter('ruleContexts', []);
          }
        }

        searchFunctionHelper.setPage(page);
        searchFunctionHelper.search();
        if (searchFunctionHelper.getPage() === 0) {
            setTimeout(() => {
              const resultsContainer = document.querySelector('.ais-hits-container') || 
                                      document.querySelector('.ais-Hits');
              if (resultsContainer) {
                  const headerHeight = parseInt(
                    getComputedStyle(document.documentElement)
                      .getPropertyValue('--header-height')
                  ) || 100;                

                  window.scrollTo({
                    top: headerHeight,
                    behavior: 'smooth'
                  });                 
              }
          }, 100);
        }
      },
    }),
    selector: results_selector + ', .algolia-shopify-instantsearch',
    sortOrders: activeSortOrders
  };
  
  instant.search.client.addAlgoliaAgent('Shopify Integration');

  algolia.instantsearch = instant;


  function readjust() {
    var width = instant.$results.offsetWidth;

    var suffix = 'lg';
    if (width < 400) suffix = 'xs';
    else if (width < 800) suffix = 'sm';
    else if (width < 1200) suffix = 'md';

    instant.$results.classList.remove('ais-results-size-xs');
    instant.$results.classList.remove('ais-results-size-sm');
    instant.$results.classList.remove('ais-results-size-md');
    instant.$results.classList.remove('ais-results-size-lg');
    instant.$results.classList.add('ais-results-size-' + suffix);
  }


  //Link CSS and set up CSS variables
  const cssFile = document.getElementById('template_algolia_instant_search.css');
  document.documentElement.style.setProperty(`--main-color`, `${algolia.config.colors.main}`);
  document.documentElement.style.setProperty(`--secondary-color`, `${algolia.config.colors.secondary}`);
  document.documentElement.style.setProperty(`--highlight-bg-color`, `${algolia.helpers.hexToRGB(algolia.config.colors.highlight)}`);
  algolia.appendStyle(cssFile.text);

  if (collectionPageEnabled) {
    if (
      document.querySelectorAll(algolia.config.collection_css_selector)
        .length === 0
    ) {
      throw new Error(
        'Instant search CSS selector for collection page is incorrect\nFor more info see: https://www.algolia.com/doc/integration/shopify/advanced-customization/collection-search-page/#css-selector'
      );
    }
  } else if (
    document.querySelectorAll(algolia.config.results_selector).length === 0
  ) {
    throw new Error(
      'Instant search CSS selector is incorrect\nFor more info see: https://www.algolia.com/doc/integration/shopify/building-search-ui/instant-search/#css-selector'
    );
  }

  // Instantiating the main page
  instant.$results = document.querySelector(instant.selector);
  instant.$results.innerHTML = '';

  algolia.render(algolia.instantSearchMainTemplate, instant.$results, {
    facets: instant.facets.list,
    multipleSortOrders: activeSortOrders.length > 1,
  });

  readjust();

  window.addEventListener('resize', function() {
    readjust();
  });

  // Mobile facets display
  instant.search.addWidgets([
  {
    init: function() {
      // var $button = document.querySelector('.ais-facets-button');
      const filterButtons = document.querySelectorAll('.ais-facets-button');
      // var $closeButton = document.querySelector('.icon__close');
      var $closeButtons = document.querySelectorAll('.icon__close, #show-results-button');
      var $facets = document.querySelector('.ais-facets');  
      
      const originalFilterBar = document.querySelector('.ais-search-header');
      const stickyFilterBtn = document.querySelector('.ais-search-header-small');

      const buttonStates = {
        open: {
          text: 'Hide filters',
          icon: ''
        },
        closed: {
          text: '',
          icon: '<svg style="width:2rem;" class="icon icon__filter" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M8.993 3.867c-.124-1.156-1.862-1.156-1.986 0L7 4v2H3l-.117.007A1 1 0 0 0 2 7l.007.117A1 1 0 0 0 3 8h4v2l.007.117A1 1 0 0 0 9 10V4l-.007-.133ZM22 7a1 1 0 0 0-1-1h-9l-.117.007A1 1 0 0 0 12 8h9l.117-.007A1 1 0 0 0 22 7ZM3 16a1 1 0 0 0-.117 1.993L3 18h9a1 1 0 0 0 .117-1.993L12 16H3Zm12.007-2.133c.124-1.156 1.862-1.156 1.986 0L17 14v2h4l.117.007A1 1 0 0 1 22 17l-.007.117A1 1 0 0 1 21 18h-4v2l-.007.117A1 1 0 0 1 15 20v-6l.007-.133Z" fill-rule="evenodd" clip-rule="evenodd"></path></svg>' +
           'Filter' +
            '<span class="filter-count"></span>'
        }
      };

      var toggleFacets = function() {
         const isOpen = $facets.classList.contains('ais-facets__shown');
         $facets.classList.toggle('ais-facets__shown', !isOpen);
          filterButtons.forEach(button => {
            if (isOpen) {
              button.innerHTML = buttonStates.closed.icon;
            } else {
              button.textContent = buttonStates.open.text;
            }
          });
        // if ($facets.classList.contains('ais-facets__shown')) {
        //   $button.innerHTML = '<svg style="width:2rem;" class="icon icon__filter" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M8.993 3.867c-.124-1.156-1.862-1.156-1.986 0L7 4v2H3l-.117.007A1 1 0 0 0 2 7l.007.117A1 1 0 0 0 3 8h4v2l.007.117A1 1 0 0 0 9 10V4l-.007-.133ZM22 7a1 1 0 0 0-1-1h-9l-.117.007A1 1 0 0 0 12 8h9l.117-.007A1 1 0 0 0 22 7ZM3 16a1 1 0 0 0-.117 1.993L3 18h9a1 1 0 0 0 .117-1.993L12 16H3Zm12.007-2.133c.124-1.156 1.862-1.156 1.986 0L17 14v2h4l.117.007A1 1 0 0 1 22 17l-.007.117A1 1 0 0 1 21 18h-4v2l-.007.117A1 1 0 0 1 15 20v-6l.007-.133Z" fill-rule="evenodd" clip-rule="evenodd"></path></svg>Filter by';
        //   $facets.classList.remove('ais-facets__shown');
        // } else {
        //   $button.textContent = 'Hide filters';
        //   $facets.classList.add('ais-facets__shown');
        // }
      };
       if (originalFilterBar && stickyFilterBtn) {
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach(entry => {
              stickyFilterBtn.style.display = entry.isIntersecting ? 'none' : 'flex';
            });
          },
          { threshold: 0.1 }
        );
        observer.observe(originalFilterBar);
      }
      // Toggle facets on click of toggle button
      filterButtons.forEach(button => {
        button.addEventListener('click', toggleFacets);
      });
    
       $closeButtons.forEach(btn => {
        btn.addEventListener('click', function() {
          if ($facets.classList.contains('ais-facets__shown')) {
            toggleFacets();
          }
        });
      });
    },
  },
]);
  instant.search.addWidgets([
    configure({
      hitsPerPage: instant.hitsPerPage,
      facetingAfterDistinct: Boolean(algolia.config.show_products),
    }),
  ]);

  // Search input
  instant.search.addWidgets([ 
    searchBox({
      container: '.ais-search-box-container',
      placeholder: algolia.translations.searchForProduct,
      showReset: false,
      showSubmit: false,
    }),
  ]);

  // Logo & clear
  instant.search.addWidgets([
    {
      init: function(opts) {
        document
          .querySelector('.ais-clear-input-icon')
          .addEventListener('click', function() {
            opts.helper.setQuery('').search();
            var input = document.querySelector('.ais-search-box--input');
            input.value = '';
            input.focus();
          });
      },
      render: function(opts) {
        if (!opts.state.query) {
          document.querySelector('.ais-clear-input-icon').style.display =
            'none';
        } else {
          document.querySelector('.ais-clear-input-icon').style.display = '';
        }
      },
    },
  ]);

  // Stats
  instant.search.addWidgets([
    stats({
      container: '.ais-stats-container',
      templates: {
        text(data, {html}){
          if(data.hasNoResults)
            return '';
            // return algolia.instantSearchStatsTemplate(data, html)
            const count = algolia.helpers.formatNumber(data.nbHits);
            const label = data.nbHits === 1 ? 'product' : 'products';
            return html`${count} ${label}`;
        }
      }
    }),
    stats({
      container: '.ais-stats-container_mobile',
      templates: {
        text(data, {html}){
          window.productSearchCount = data.nbHits;     
          const btn = document.getElementById('show-results-button');
          if (btn && data.nbHits) {
            btn.textContent = `Show ${data.nbHits} Products`;
          }
          // return algolia.instantSearchStatsTemplate(data, html)
          if(data.hasNoResults)
            return '';
            const count = algolia.helpers.formatNumber(data.nbHits);
            const label = data.nbHits === 1 ? 'product' : 'products';
            return html`(${count} ${label})`;
        }
      }
    }),
  ]);

  // Sort orders
  if (activeSortOrders.length > 1) {
    instant.search.addWidgets([
      sortBy({
        container: '.ais-sort-orders-container',
        items: instant.sortOrders,
      }),
    ]);
  }



  // Hidden facets
  var list = instant.facets.hidden.map(function(facet) {
    return facet.name;
  });
  instant.search.addWidgets([
    {
      getConfiguration: function() {
        return {
          facets: list,
          disjunctiveFacets: list,
        };
      },
      init: function() {},
    },
  ]);

  // Create the render function
  var createDataAttributes = function(refinement) {
    return Object.keys(refinement)
      .map(function(key) {
        return 'data-' + key + '="' + encodeURIComponent(refinement[key] || '') + '"';
      })
      .join(' ');
  };

  var renderListItem = function(item) {
    var facet = instant.facets.list.find(function(f) {
      return f.name === item.label;
    });
    return item.refinements
      .map(function(refinement) {
        return (
          '<li class="ais-current-refined-values--item">' +
          '  <a ' +
          createDataAttributes(refinement) +
          '    class="ais-current-refined-values--link">' +
          '    <div>' +
          '      <div class="ais-current-refined-values--label">' +
          '      </div> ' +
          refinement.label +'<svg class="icon icon__close" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M6.251 6.251a.857.857 0 0 1 1.212 0L12 10.788l4.537-4.537a.857.857 0 0 1 1.283 1.131l-.071.081L13.212 12l4.537 4.537.071.08a.857.857 0 0 1-1.283 1.132L12 13.212 7.463 17.75a.857.857 0 0 1-1.283-1.131l.071-.081L10.788 12 6.25 7.463l-.071-.08A.857.857 0 0 1 6.25 6.25Z" fill-rule="evenodd" clip-rule="evenodd"></path></svg>'+
          '    </div>' +
          '  </a>' +
          '</li>'
        );
      })
      .join('');
  };
  let hasFiredViewDFiltersOnLoad = false;
  let currentFilterCount = 0;
  let observer_filter;
  var renderCurrentRefinements = function(renderOptions) {
    var items = renderOptions.items;
    var refine = renderOptions.refine;
    var widgetParams = renderOptions.widgetParams;   
    widgetParams.container.innerHTML =
     
      '<div class="ais-root ais-current-refined-values ais-facet">' +
      '  <ul class="ais-current-refined-values--list">' +
      items.map(renderListItem).join('') +
      '  </ul>' +
      '</div>';

    Array.prototype.slice
      .call(
        widgetParams.container.querySelectorAll(
          '.ais-current-refined-values--link'
        )
      )
      .forEach(function(element) {
        element.addEventListener('click', function(event) {
          var item = Object.keys(event.currentTarget.dataset).reduce(function(
            acc,
            key
          ) {
            var itemData = {};
            itemData[key] = decodeURIComponent(event.currentTarget.dataset[key]);
            return algolia.assign({}, acc, itemData);
          },
          {});

          refine(item);
        });
      });

      updateFilterCount(items);
      if (!observer_filter) {
        setupMutationObserver();
      }
     if (!hasFiredViewDFiltersOnLoad && items.length > 0) {
      hasFiredViewDFiltersOnLoad = true;
      const filters = [];  
       
      items.forEach(item => {
        item.refinements.forEach(refinement => {
          filters.push(`${encodeURIComponent(item.label)}:${encodeURIComponent(refinement.label)}`);
        });
      });
      const user_Token = localStorage.getItem('_ALGOLIA_USER_TOKEN');
      // setTimeout(function(){
      //    aa('viewedFilters', {
      //     userToken: user_Token,
      //     index: `${window.algoliaShopify.config.index_prefix}products`,         
      //     eventName: 'viewedFilters',          
      //     filters: filters
      //   });
      // },500);
      
    }
  };
  function updateFilterCount(items) {
    const newCount = items.reduce((acc, item) => acc + item.refinements.length, 0);
    
    if (newCount !== currentFilterCount) {
      currentFilterCount = newCount;
      updateCountDisplays();
    }
  }
  function updateCountDisplays() {
    const countContainers = document.querySelectorAll('.filter-count');
    
    countContainers.forEach(container => {
      if (currentFilterCount > 0) {
        container.textContent = currentFilterCount;
        container.style.display = 'inline-block';
      } else {
        container.textContent = '';
        container.style.display = 'none';
      }
    });
  }
  function setupMutationObserver() {      
    observer_filter = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'childList') {
          // Check if any filter buttons were added/modified
          const addedButtons = Array.from(mutation.addedNodes).filter(node => 
            node.classList && node.classList.contains('ais-facets-button')
          );
          
          if (addedButtons.length > 0 || 
              mutation.target.classList.contains('ais-facets-button')) {
            updateCountDisplays();
          }
          }
        });
    });
    // Observe the search container
    const searchContainer = document.querySelector('.ais-page');
    if (searchContainer) {
      observer_filter.observe(searchContainer, {
        childList: true,
        subtree: true
      });
    }
  }
  // Create the custom widget
  var customCurrentRefinements = connectCurrentRefinements(
    renderCurrentRefinements
  );

  var hasRefinements = function(helper, facetsList) {
    return facetsList.some(function(f) {
      var isConjunctiveFacetRefined =
        helper.state.isConjunctiveFacet(f.name) &&
        helper.state.isFacetRefined(f.name);
      var isDisjunctiveFacetRefined =
        helper.state.isDisjunctiveFacet(f.name) &&
        helper.state.isDisjunctiveFacetRefined(f.name);
      var isHierarchicalFacetRefined =
        helper.state.isHierarchicalFacet(f.name) &&
        helper.state.isHierarchicalFacetRefined(f.name);

      var numericRefinements = helper.state.getNumericRefinements(f.name);
      var isNumericFacetRefined = Object.keys(numericRefinements).some(function(
        operator
      ) {
        return numericRefinements[operator].length > 0;
      });

      return (
        isNumericFacetRefined ||
        isConjunctiveFacetRefined ||
        isDisjunctiveFacetRefined ||
        isHierarchicalFacetRefined
      );
    });
  };

  /**
   * Decides whether the given `facetName` has any facet values available in
   * the current result set by checking the available `facets`,
   * `disjunctiveFacets` and `hierarchicalFacets`.
   */
  var hasFacetValues = function(resultState, facetName) {
    var isFacetValueAvailable = resultState.facets.some(function(facet) {
      return facet.name === facetName;
    });
    var isDisjunctiveFacetValueAvailable = resultState.disjunctiveFacets.some(
      function(facet) {
        return facet.name === facetName;
      }
    );
    var isHierarchicalFacetValueAvailable = resultState.hierarchicalFacets.some(
      function(facet) {
        return facet.name === facetName;
      }
    );

    return (
      isFacetValueAvailable ||
      isDisjunctiveFacetValueAvailable ||
      isHierarchicalFacetValueAvailable
    );
  };

  var customCurrentRefinementsWithPanel = panel({
    hidden: function(options) {
      return !hasRefinements(options.helper, instant.facets.list);
    },
  })(customCurrentRefinements);

  var clearRefinementsWithPanel = panel({
    // hidden: function(options) {
    //   return !hasRefinements(options.helper, instant.facets.list);
    // },
  })(clearRefinements);

  instant.search.addWidgets([
    clearRefinementsWithPanel({
      container: document.querySelector('.ais-clear-refinements-container'),
      templates: {
        resetLabel: algolia.translations.clearAll,
      },
    }),
    customCurrentRefinementsWithPanel({
      container: document.querySelector(
        '.ais-current-refined-values-container'
      ),
    }),
  ]);
  // for clearbutton
  const stickyClearRefinementsWithPanel = panel({
      hidden: function(options) {
        return !hasRefinements(options.helper, instant.facets.list);
      },
    })(clearRefinements);

  instant.search.addWidgets([
    stickyClearRefinementsWithPanel({
      container: document.querySelector('.ais-clear-refinements-container--sticky'),
      templates: {
        resetLabel: algolia.translations.clearAll,
      },
    }),
  ]);
  /**
   * Setup the facets for search.
   * We are using a `panel` with a custom `hidden` function which will allow
   * us to hide the parent container of the facet if there are no facet values
   * available for that particular facet.
   */
  instant.facets.widgets.forEach(function(widget) {
    var facetWithPanel = panel({
      hidden: function(options) {
        var hide = !hasFacetValues(options.results, widget.params.attribute);
        var displayStyle = hide ? 'none' : '';

        /**
         * Replacing any "." and "%" in the class name with "\." and "\%" so that querySelector
         * can work as expected. "." is supposed to be present for named tags
         * and metafield based facet names and "%" is present when the facet name has a space
         * in it because of the encoding.
         */
        var parentContainerClassName = '.ais-facet-' + encodeURIComponent(
          widget.params.attribute
        ).replace(/\./g, '\\.').replace(/\%/g, '\\%');
        var parentContainer = document.querySelector(parentContainerClassName);

        if (parentContainer) {
          parentContainer.style.display = displayStyle;
        }

        return hide;
      },
    })(widget.widget);

    instant.search.addWidgets([facetWithPanel(widget.params)]);
  });

  // Hits
  instant.search.addWidgets([
    hits({
      container: '.ais-hits-container',
      showPrevious: true,
      templates: {
        item(hit, {html, components}) {
          return algolia.instantSearchProductTemplate(hit, html, components);
        },
        empty(results, {html}) {
          return algolia.instantSearchNoResultTemplate(html);
        },
        showPreviousText(data, { html }) {
          return html`<span>${algolia.translations.loadprevious}</span>`;
        },
        showMoreText(data, { html }) {
          const helper = instant.search.helper;
          const results = helper.lastResults;
          
          if (!results) return html`<span>${algolia.translations.loadmore}</span>`;

         const totalHits = results.nbHits;
        
        const hitsPerPage = helper.state.hitsPerPage;
        const currentPage = helper.state.page || 0;
        const loadedHits = (currentPage + 1) * hitsPerPage;
        const remainingHits = Math.max(0, totalHits - loadedHits);
        
        // Calculate exactly how many will load on next click
        const nextLoadCount = Math.min(hitsPerPage, remainingHits);       
        return html`
          <span class="load-more-text">
            Load Next 
            ${remainingHits > 0 ? ` ${nextLoadCount}` : ''}
          </span>
        `;            
          // return html`<span>${algolia.translations.loadmore}</span>`;
        },
        searchableLoadingIndicator(data, { html }) {
          return html`<span>loading</span>`;
        }
      },
      transformItems: function(items) {
        return items.map( item => ({
          ...item,
          _distinct: instant.distinct,
          can_order:
            item.inventory_management !== 'shopify' ||
            item.inventory_policy === 'continue' ||
            item.inventory_quantity > 0,
          queryID: item.__queryID,
          productPosition: item.__position,
          index: instant.search.mainIndex.getIndexName()
        }));
      }
    })
  ]);
  instant.search.on('render', () => {
    wrapper_track_addtocart_buttons();  
  });
  // Redirect to product on click
  instant.search.addWidgets([
    {
      init: function() {
        var container = document.querySelector('.ais-hits-container');
        container.addEventListener('click', function(e) {
          const cartButton = e.target.closest('.ais-hit--cart-button_custom');
            if (cartButton) {           
              return;
            }
          var el = e.target;
          var hit;
          do {
            if (el.matches('.ais-product')) {
              hit = el;
              break;
            }
            el = el.parentNode;
          } while (el && el !== container);
          if (!hit) {
            return;
          }
          var $this = hit;
          var productHandle = $this.dataset.handle;
          var variant_id = $this.dataset.variantId;
          var distinct = $this.dataset.distinct;
          const isSearch = $this.dataset.source === 'search';

          // Construct the link we should redirect to
          var link = '';

          // If we're on a collection page and the handle is available
          // then prefix the product link with the collection handle
          if (collectionPageEnabled && collectionHandle) {
            link = `${window.Shopify.routes.root}collections/${collectionHandle}`;
          }

          // Add the product handle to the link
          let rootWithoutAr = window.Shopify.routes.root.replace('/ar/', '/');
          link = link + rootWithoutAr + 'products/' + productHandle;
          // Add the variant ID details to redirect to a specific
          // variant ID if we are showing variants and not products
          if (distinct !== 'true') {
            link += '?variant=' + variant_id;
          }
            if (isSearch) {           
              localStorage.setItem('algolia_queryID', hit.dataset.algoliaQueryid);
              localStorage.setItem('algolia_objectID', hit.dataset.algoliaObjectid);   
              const userToken = localStorage.getItem('_ALGOLIA_USER_TOKEN');
              const authenticatedUserToken = window.algoliaShopify?.authenticatedUserToken || undefined;
               aa('clickedObjectIDsAfterSearch', {
                userToken: userToken,              
                authenticatedUserToken: authenticatedUserToken,
                index: window.algoliaShopify.dynamicIndexName || hit.dataset.algoliaIndex,
                eventName: 'clickedObjectIDsAfterSearch',                    
                queryID: hit.dataset.algoliaQueryid,
                objectIDs: [hit.dataset.algoliaObjectid],
                positions: [parseInt(hit.dataset.algoliaPosition, 10)]
              });
            }
          window.location.href = link;
        });
      },
    },
  ]);

  // Add to cart
  instant.search.addWidgets([
    {
      init: function() {
        var container = document.querySelector('.ais-hits-container');
        container.addEventListener('click', function(e) {
          var el = e.target;
          var cartButton;
          do {
            if (el.matches('.ais-hit--cart-button')) {
              cartButton = el;
              break;
            }
            el = el.parentNode;
          } while (el && el !== container);
          if (!cartButton) {
            return;
          }

          e.stopPropagation();
          var $this = cartButton;
          var formId = $this.dataset.formId;

          if (formId) {
            document.getElementById(formId).submit();
          }
        });
      },
    },
  ]);
    
  let lastProcessedHits = [];
  let processing = false;

  instant.search.on('render', function() {
    const select = document.querySelector('.ais-SortBy-select');
    if (select && !select.dataset.listenerAttached) {
      select.dataset.listenerAttached = 'true';   
      updateDynamicIndex(select.value);            
      select.addEventListener('change', (e) => {        
        var selectedOption = e.target.value;
        updateDynamicIndex(selectedOption);       
      });      
    }    
    if (processing) return;
    processing = true;
    
    const currentHits = instant.search.helper?.lastResults?.hits || [];
    const hitsChanged = JSON.stringify(currentHits) !== JSON.stringify(lastProcessedHits);
    
    if (hitsChanged && currentHits.length > 0) {      
      lastProcessedHits = currentHits;
      
      // Get objectIDs for tracking
      const objectIDs = currentHits.map(hit => hit.objectID);      
      const eventName = window.location.pathname.includes('/collections/') 
        ? 'Collection Viewed' 
        : 'Search Results Viewed';
      const user_Token = localStorage.getItem('_ALGOLIA_USER_TOKEN');
      const authenticatedUserToken = window.algoliaShopify?.authenticatedUserToken || undefined;
      // Send viewedObjectIDs event
      if (typeof aa === 'function') {
        setTimeout(() => {
          aa('viewedObjectIDs', {
            eventName: 'viewedObjectIDs',
            index: window.algoliaShopify.dynamicIndexName || instant.search.helper.lastResults.index,
            objectIDs: objectIDs,
            userToken: user_Token,
            authenticatedUserToken: authenticatedUserToken
          });
        }, 800);  
      }
    }
    
    processing = false;   
  });
  // No result actions
  instant.search.addWidgets([
    {
      init: function(opts) {
        var container = document.querySelector('.ais-hits-container');
        container.addEventListener('click', function(e) {
          var el = e.target;
          var clearFilters;
          do {
            if (el.matches('.ais-hit-empty--clear-filters')) {
              clearFilters = el;
              break;
            }
            el = el.parentNode;
          } while (el && el !== container);
          if (!clearFilters) {
            return;
          }

          var helper = opts.helper;
          helper.clearTags();
          instant.facets.list.forEach(function(facet) {
            helper.clearRefinements(facet.name);
          });
          helper.search();
        });

        container.addEventListener('click', function(e) {
          var el = e.target;
          var clearInput;
          do {
            if (el.matches('.ais-hit-empty--clear-input')) {
              clearInput = el;
              break;
            }
            el = el.parentNode;
          } while (el && el !== container);
          if (!clearInput) {
            return;
          }

          opts.helper.setQuery('').search();
          var input = document.querySelector('.ais-search-box--input');
          input.value = '';
          input.focus();
        });
      },
    },
  ]);
  
  instant.search.start();
  algolia.contentHide.parentNode.removeChild(algolia.contentHide);

  instant.search.on('render', () => {
  // Force update the button text after each render
    const loadMoreBtn = document.querySelector('.ais-InfiniteHits-loadMore');
    const helper = instant.search.helper;
    const results = helper.lastResults;
    if (loadMoreBtn) {    
      if (!results) return;   
        const totalHits = results.nbHits;            
        const hitsPerPage = helper.state.hitsPerPage;
        const currentPage = helper.state.page || 0;
        const loadedHits = (currentPage + 1) * hitsPerPage;

        const remainingHits = Math.max(0, totalHits - loadedHits);
        const nextLoadCount = Math.min(hitsPerPage, remainingHits);
        const textSpan = loadMoreBtn.querySelector('.load-more-text');
        if (textSpan) {
          textSpan.textContent = `Load next ${remainingHits > 0 ? `${nextLoadCount}` : ''}`;
        }
    }
    const tryInjectProgressBar = () => {
      const hitsContainer = document.querySelector('.ais-InfiniteHits-list');
      if (!hitsContainer) return;
      // Only inject once
      let progressContainer = document.querySelector('.custom-load-more-container');
      if (!progressContainer) {
        progressContainer = document.createElement('div');
        progressContainer.className = 'custom-load-more-container';
        progressContainer.innerHTML = `
          <div class="progress-text"></div>
          <div class="progress-bar"><div class="progress-fill"></div></div>
        `;
        hitsContainer.parentNode.insertBefore(progressContainer, hitsContainer.nextSibling);
      }

        if (results) {
          const totalHits = results.nbHits;
          const hitsPerPage = helper.state.hitsPerPage;
          const currentPage = helper.state.page || 0;
          const loadedHits = (currentPage + 1) * hitsPerPage;

          // const viewedHits = results.hits.length;
          const remainingHits = Math.max(0, totalHits - loadedHits);
          const viewedHits = Math.max(0, totalHits - remainingHits);
          const percentViewed = Math.min((viewedHits / totalHits) * 100, 100);
                  
          const progressText = progressContainer.querySelector('.progress-text');
          const progressFill = progressContainer.querySelector('.progress-fill');
          
          if (progressText && progressFill) {
            progressText.textContent = `You've viewed ${viewedHits} of ${totalHits} products`;
            progressFill.style.width = `${percentViewed}%`;
          }
        }
    };
    tryInjectProgressBar();
  });
  // Add this function to create mobile sort popup
  function initMobileSortPopup() {
    // Get elements
    const mobileSortButton = document.querySelector('.mobile-sort-button');
    const bottomSortButton = document.querySelector('.bottom-sort-button');
    const mobileSortPopup = document.querySelector('.mobile-sort-popup');
    const mobileSortOptions = document.querySelector('.mobile-sort-options');
    const algoliaSelect = document.querySelector('.ais-sort-orders-container select');
    const closeButtons = document.querySelectorAll('.mobile-sort-close, .mobile-sort-overlay');
    const currentSortLabel = document.querySelector('.current-sort-label');
    
    if (!algoliaSelect || !mobileSortButton) return;
    
    // Show mobile button on mobile
    mobileSortButton.style.display = window.innerWidth <= 990 ? 'flex' : 'none';

    function updateCurrentSortLabel() {
      const selectedOption = algoliaSelect.options[algoliaSelect.selectedIndex];
      if (selectedOption) {
        currentSortLabel.textContent = selectedOption.textContent;
      }
    }

    function highlightActiveOption() {
      const selectedValue = algoliaSelect.value;
      const options = mobileSortOptions.querySelectorAll('.mobile-sort-option');
      
      options.forEach(option => {
        option.classList.remove('active');
        if (option.dataset.value === selectedValue) {
          option.classList.add('active');
        }
      });
    }
    
    // Copy options from Algolia select to custom popup
    function copySortOptions() {
      mobileSortOptions.innerHTML = '';
      
      Array.from(algoliaSelect.options).forEach(option => {
        const button = document.createElement('button');
        button.className = 'mobile-sort-option';
        button.textContent = option.textContent;
        button.dataset.value = option.value;

        if (option.value === algoliaSelect.value) {
          button.classList.add('active');
        }
        
        button.addEventListener('click', () => {
          // Update the original Algolia select
          algoliaSelect.value = option.value;                  
          algoliaSelect.dispatchEvent(new Event('change'));
          highlightActiveOption();
          
          // Close popup
          mobileSortPopup.classList.remove('show');
        });
        
        mobileSortOptions.appendChild(button);
      });
    }
    
    function openSortPopup() {
      if (mobileSortPopup) {
        mobileSortPopup.classList.add('show');
        copySortOptions();
      }
    }  
    if (mobileSortButton) {
      bindSortButton(mobileSortButton);
    }
    function bindSortButton(button) {
      if (!button) return;

      // Handle both click and touch for iOS
      ["click", "touchend"].forEach(eventName => {
        button.addEventListener(eventName, (e) => {
          e.preventDefault(); // Prevent ghost clicks on iOS
          openSortPopup();
        }, { passive: false });
      });
    }
    if (bottomSortButton) {    
      bindSortButton(bottomSortButton);
    }
    
    // Close popup
    closeButtons.forEach(btn => {
      btn.addEventListener('click', () => {
        mobileSortPopup.classList.remove('show');
      });
    });
    algoliaSelect.addEventListener('change', updateCurrentSortLabel);
    // Handle window resize
    window.addEventListener('resize', () => {
      mobileSortButton.style.display = window.innerWidth <= 990 ? 'flex' : 'none';
    });
    updateCurrentSortLabel();
  }

  // Initialize when page loads
  document.addEventListener('DOMContentLoaded', function() {    
    setTimeout(initMobileSortPopup, 2000);
  });

})(window.algoliaShopify);
function sendViewedFiltersOnLoad() { 
  const viewedFilters = [];
  const facetGroups = Array.from(document.querySelectorAll('.ais-facet'))
  .filter(facet => facet.closest('.ais-facet-dropdown-wrapper'));
  let facetCount = 0;
  
  facetGroups.forEach(group => {       
    const dropdownWrapper = group.closest('.ais-facet-dropdown-wrapper');   
    const groupName = dropdownWrapper.querySelector('.ais-facet--header')?.innerText.trim() || '';

    if (!groupName) return;

    const isPriceFacet = group.closest('.ais-facet-price');
    if (isPriceFacet) {     
      if (facetCount >= 10) return;
      const lowerHandle = isPriceFacet.querySelector('.rheostat-handle-lower');
      const upperHandle = isPriceFacet.querySelector('.rheostat-handle-upper');

      const minVal = lowerHandle ? lowerHandle.getAttribute('aria-valuenow') : '';
      const maxVal = upperHandle ? upperHandle.getAttribute('aria-valuenow') : '';
      
      if (minVal || maxVal) {
        viewedFilters.push(`Price:${minVal || 'min'}-${maxVal || 'max'}`);
      } else {       
        viewedFilters.push('Price:All');
      }
      facetCount++;
    }
  
    const options = Array.from(group.querySelectorAll('.ais-RefinementList-item')).map(item => {
      // Stop processing if we already have 10 values
      if (facetCount >= 10) return null;   
      const checkbox = item.querySelector('input.ais-facet--checkbox');   
      const label = item.querySelector('label.ais-facet--label')?.innerText.trim() || '';           
      const cleanLabel = label.replace(/\s*\(\d+\)\s*$/, '').trim(); // remove count from label
      
      facetCount++;
      
      return {
        label: cleanLabel,
        value: checkbox?.dataset?.value || cleanLabel        
      };
    }).filter(option => option !== null); 
  
    options.forEach(option => {
      viewedFilters.push(`${groupName}:${option.label}`);
    });    
   
  });  
  sendAlgoliaViewedFiltersEvent(viewedFilters);
}
function sendAlgoliaViewedFiltersEvent(filters) {
  if (!filters || filters.length === 0) {
    console.log('No filters to send to Algolia');
    return;
  }
  
  const user_Token = localStorage.getItem('_ALGOLIA_USER_TOKEN');
  const authenticatedUserToken = window.algoliaShopify?.authenticatedUserToken || undefined;
  const locale = window.Shopify.locale || 'en';
  let indexName;

  if (locale === 'ar') {     
    indexName = 'shopify_products_saudi_arabia_ar';
  } else {     
    indexName = `${window.algoliaShopify.config.index_prefix}products`;
  }

  setTimeout(function(){
      aa('viewedFilters', {
      userToken: user_Token,
      authenticatedUserToken: authenticatedUserToken,
      index: window.algoliaShopify.dynamicIndexName || indexName,          
      eventName: 'viewedFilters',
      filters: filters
    });
  },500);
}
function handleDropdownToggle(dropdownWrapper, facetCount = 0) {
  if (!dropdownWrapper) return;
  const { viewedFilters, facetCount: updatedCount } = getViewedFiltersForDropdown(dropdownWrapper);
  if (viewedFilters.length > 0) {
    sendAlgoliaViewedFiltersEvent(viewedFilters);    
  }
  return updatedCount;
}
function getViewedFiltersForDropdown(dropdownWrapper, facetCount = 0) {
  const viewedFilters = [];

  if (!dropdownWrapper) return viewedFilters;

  const groupName = dropdownWrapper.querySelector('.ais-facet--header')?.innerText.trim() || '';
  if (!groupName) return viewedFilters;

  // Handle price facet first
  if (dropdownWrapper.classList.contains('ais-facet-price') || dropdownWrapper.querySelector('.ais-facet-price')) {
    if (facetCount < 10) {
      const lowerHandle = dropdownWrapper.querySelector('.rheostat-handle-lower');
      const upperHandle = dropdownWrapper.querySelector('.rheostat-handle-upper');
      const min = lowerHandle?.getAttribute('aria-valuenow');
      const max = upperHandle?.getAttribute('aria-valuenow');

      if (min || max) {
        viewedFilters.push(`${groupName}:${min || 'min'}-${max || 'max'}`);
      } else {
        viewedFilters.push(`${groupName}:All`);
      }
      facetCount++;
    }
    return { viewedFilters, facetCount };
  }

  // Get the facet group inside this dropdown
  const facetGroup = dropdownWrapper.querySelector('.ais-facet');
  if (!facetGroup) return { viewedFilters, facetCount };

  // Get first visible filter values up to 10 total
  Array.from(facetGroup.querySelectorAll('.ais-RefinementList-item')).forEach(item => {
    if (facetCount >= 10) return;

    const label = item.querySelector('label.ais-facet--label')?.innerText.trim() || '';
    const cleanLabel = label.replace(/\s*\(\d+\)\s*$/, '').trim();
    if (cleanLabel) {
      viewedFilters.push(`${groupName}:${cleanLabel}`);
      facetCount++;
    }
  });
  return { viewedFilters, facetCount };
}
function onAlgoliaRendered(callback) {
  const runCallback = () => {
    const algoliaContainer = document.querySelector('.ais-facets');
    if (!algoliaContainer) return false;

    // Ensure there are facet items inside
    const facets = algoliaContainer.querySelectorAll('.ais-facet');
    if (facets.length === 0) return false;

    callback();
    return true;
  };

  if (!runCallback()) {
    const observer = new MutationObserver((mutations, obs) => {
      if (runCallback()) {
        obs.disconnect(); 
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
}
onAlgoliaRendered(() => { 
  if (window.innerWidth >= 992) {
    sendViewedFiltersOnLoad();
  }
});
function updateDynamicIndex(indexName) {
  if (!indexName) return;
  window.algoliaShopify = window.algoliaShopify || {};
  window.algoliaShopify.dynamicIndexName = indexName;  
  const al_config = JSON.parse(localStorage.getItem('algolia_config') || '{}');
  al_config.index_name = indexName;
  localStorage.setItem('algolia_config', JSON.stringify(al_config));
}